import { Box, Typography } from "@mui/material";
import React from "react";
import AppConsole from "../../../components/console/console";
import CustomDialog from "../../../elements/CustomDialog";
import { useStyles } from "./styles";

const CheckovDetails = ({ data, onClose }) => {
  const { passed, failed, skipped, parsing_errors, resource_count, logs } =
    data?.actions?.checkov || {};
  const classes = useStyles();

  const contentData = [
    { label: "Passed", value: passed },
    { label: "Failed", value: failed },
    { label: "Skipped", value: skipped },
    { label: "Parsing Errors", value: parsing_errors },
    { label: "Resource Count", value: resource_count },
  ];

  return (
    <CustomDialog
      open={Boolean(data)}
      title="Checkov Details"
      onClose={onClose}
    >
      <Box className={classes.dialogContent}>
        {contentData.map((obj) => {
          return (
            <Typography>
              {obj.label} : <b>{obj.value}</b>
            </Typography>
          );
        })}
      </Box>
      <AppConsole logs={logs || ["No logs available"]} />
    </CustomDialog>
  );
};

export default CheckovDetails;
